import { useState } from "react";
import HomePage from "pages/Home/HomePage";
import BussinessPage from "pages/BussinessPage";
import ProductPage from "pages/ProductPage";
import ClubPage from "pages/ClubPage";
import FinancialManagement from "pages/FinancialManagement";
import WalletList from "pages/WalletList";
import OrdersSuperAdmin from "pages/OrdersSuperAdmin";
import CustomerManagment from "pages/CustomerManagment";
import img from "assets/images/effective-business-team-office-group-work-vector-34356039.jpg";

export default function ManagementContent({ requestId, accessLevel }) {
  const [itemss, setItemss] = useState([]);
  const [updater, setUpdater] = useState(false);

  return (
    <>
      <div class="tab-content container" id="pills-tabContent">
        <div
          class="tab-pane fade container active show text-center"
          id="pills-welcome"
          role="tabpanel"
          aria-labelledby="pills-welcome-tab"
        >
          <div className="">
            <img src={img} style={{ width: "50%" }} />
            <h5> به مدیریت سبدی خوش آمدید</h5>
          </div>
        </div>

        <div
          class="tab-pane fade "
          id="pills-dashboard"
          role="tabpanel"
          aria-labelledby="pills-dashboard-tab"
        >
          {requestId.includes(1) && (
            <HomePage
              itemss={itemss}
              setItemss={setItemss}
              setUpdater={setUpdater}
              updater={updater}
            />
          )}
        </div>
        <div
          class="tab-pane fade "
          id="pills-business"
          role="tabpanel"
          aria-labelledby="pills-business-tab"
        >
          {requestId.includes(2) && <BussinessPage accessLevel={accessLevel} />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-product"
          role="tabpanel"
          aria-labelledby="pills-product-tab"
        >
          {requestId.includes(3) && <ProductPage accessLevel={accessLevel} />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-customerClub"
          role="tabpanel"
          aria-labelledby="pills-customerClub-tab"
        >
          {requestId.includes(4) && <ClubPage />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-finance"
          role="tabpanel"
          aria-labelledby="pills-finance-tab"
        >
          {requestId.includes(5) && <FinancialManagement />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-wallet"
          role="tabpanel"
          aria-labelledby="pills-wallet-tab"
        >
          {requestId.includes(6) && <WalletList />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-order"
          role="tabpanel"
          aria-labelledby="pills-order-tab"
        >
          {requestId.includes(7) && <OrdersSuperAdmin />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-user"
          role="tabpanel"
          aria-labelledby="pills-user-tab"
        >
          {" "}
          {requestId.includes(8) && <CustomerManagment />}
        </div>
      </div>
    </>
  );
}
